import { render, staticRenderFns } from "./EmProductDetail.vue?vue&type=template&id=2d532edd&"
import script from "./EmProductDetail.vue?vue&type=script&lang=js&"
export * from "./EmProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./EmProductDetail.vue?vue&type=style&index=0&lang=scss&slot-scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EmProductDetail.vue"
export default component.exports